import { z } from 'zod';

import {
  DELIVERY_NOTE_ASSIGNMENT_MAX_DELIVERY_NOTES,
  DELIVERY_NOTE_ASSIGNMENT_REASON,
  DELIVERY_NOTE_ASSIGNMENT_SOURCE,
} from './constants';

const zodDecimalSchema = z.string().nullable();

export const zodDeliveryNoteAssignmentProposalPayloadSchema = z.object({
  deliveryNoteIds: z
    .array(z.uuid())
    .min(1)
    .max(DELIVERY_NOTE_ASSIGNMENT_MAX_DELIVERY_NOTES),
});

export const zodDeliveryNoteAssignmentArticleSchema = z.object({
  deliveryDate: z.iso.date().nullable(),
  deliveryNoteId: z.uuid(),
  deliveryNoteNumber: z.string(),
  itemIndex: z.number().int().nonnegative(),
  lineCount: z.number().int().nonnegative(),
  lineItemId: z.uuid().nullable(),
  linkedLineItemIds: z.array(z.uuid()),
  name: z.string().nullable(),
  quantity: zodDecimalSchema,
  quantityInLineUnit: zodDecimalSchema,
  reasons: z.array(z.enum(DELIVERY_NOTE_ASSIGNMENT_REASON)),
  sellerAssignedId: z.string().nullable(),
  source: z.enum(DELIVERY_NOTE_ASSIGNMENT_SOURCE).nullable(),
  unit: z.string().nullable(),
  unitFits: z.boolean().nullable(),
});

export const zodDeliveryNoteAssignmentCandidateSchema = z.object({
  lineItemId: z.uuid(),
  manualLinkCount: z.number().int().nonnegative(),
  name: z.string().nullable(),
  position: z.number().int().nullable(),
  quantity: zodDecimalSchema,
  sellerAssignedId: z.string().nullable(),
  unit: z.string().nullable(),
});

export const zodDeliveryNoteAssignmentProposalSchema = z.object({
  candidatePositions: z.array(zodDeliveryNoteAssignmentCandidateSchema),
  data: z.array(zodDeliveryNoteAssignmentArticleSchema),
  needsLineMapping: z.boolean(),
  selectedArticleCount: z.number().int().nonnegative(),
  unassignedArticleCount: z.number().int().nonnegative(),
  unassignedPositionCount: z.number().int().nonnegative(),
});
